import { T } from "@tolgee/react";
import { FC } from "react";

export const BomPageExplainerFooter: FC = () => {
  return (
    <div className="flex flex-col gap-[0.3125rem]">
      <div className="text-sm font-medium text-gray-800">
        <T keyName="pq-bom-t1-product-page-instructions-modal-content-3-title" />
      </div>
      <div className="font-normal text-gray-700 text-xxs">
        <T keyName="pq-bom-t1-product-page-instructions-modal-content-3-text" />
      </div>
    </div>
  );
};
